import React from 'react';
import './spinner.scss';
export var SpinnerSize;
(function (SpinnerSize) {
    SpinnerSize["XLarge"] = "x-large";
    SpinnerSize["Large"] = "large";
    SpinnerSize["Medium"] = "medium";
    SpinnerSize["Small"] = "small";
    SpinnerSize["XSmall"] = "x-small";
})(SpinnerSize || (SpinnerSize = {}));
export const Spinner = ({ label, size = SpinnerSize.Large, withBlur = false, className = '' }) => {
    return <>
    <div className={`spinner spinner_size_${size} ${withBlur ? 'spinner_with-blur' : ''} ${className}`}>
      <div className={'spinner__svg-wrapper'}>
        <svg viewBox='25 25 50 50'>
          <circle cx='50' cy='50' r='21' fill='none' strokeMiterlimit='10' vectorEffect='non-scaling-stroke'/>
        </svg>
      </div>
      {label
            &&
                <div className={'spinner__label'}>{label}</div>}
    </div>
    {withBlur
            &&
                <div className={'spinner__blur'}/>}
  </>;
};
